/** @format */

import React, { MouseEventHandler } from "react";
import styled from "styled-components";
import ImgPdf from "../../../images/PDF_32.png";
import ImgIconClose from "../../../images/icon_ng_white.svg";
import { fonts } from "../../../css/variables/fonts";
import { colors } from "../../../css/variables/colors";
import { sessionFileType } from "../../../constance/typeModel";

const FileItemStyle = styled.li`
  margin-top: 6px;
  position: relative;
  width: 100px;
  display: block;
`;
const ImgWrapStyle = styled.div`
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6e6e6;
`;
const DeleteButtonStyle = styled.button`
  border: none;
  background: rgba(0, 0, 0, 0.5);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: -6px;
  right: -6px;
`;
const FilenameStyle = styled.span`
  display: block;
  word-wrap: break-word;
  font-size: ${fonts.fontSizeRem("xxs")};
  color: ${colors.themeColor("text_lightgray")};
  margin-top: 4px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

const FileItem = ({
  file,
  onClickCloseBtn,
}: {
  file: sessionFileType;
  onClickCloseBtn: MouseEventHandler<HTMLElement>;
}) => {
  return (
    <FileItemStyle>
      <ImgWrapStyle>
        {file.type !== undefined && (file.type.match(/image/) || file.type.match(/application/)) ? (
          <img src={file.file_data ? file.file_data : file.file_url} alt={file.file_name_origin} />
        ) : (
          <img src={ImgPdf} alt={file.file_name_origin} />
        )}
      </ImgWrapStyle>
      <FilenameStyle>{file.file_name_origin}</FilenameStyle>
      <DeleteButtonStyle onClick={onClickCloseBtn}>
        <img src={ImgIconClose} alt="削除" />
      </DeleteButtonStyle>
    </FileItemStyle>
  );
};

export default FileItem;
